/* assets/j_cart-free-guard.js
   NJC free gift guard.
   - Free/reward/gift items max quantity 1
   - Duplicate free gift lines removed
   - If same variant exists as paid + free, paid item wins and free duplicate is removed
*/

(function () {
  if (window.__j_cart_free_guard_active) return;
  window.__j_cart_free_guard_active = true;

  var isRunning = false;
  var timer = null;

  function isTrue(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
  }

  function normalize(value) {
    return String(value || '').trim().toUpperCase();
  }

  function isFreeGiftLine(item) {
    var props = item && item.properties ? item.properties : {};
    var title = normalize(item && item.product_title);
    var finalPrice = Number(item && item.final_price || 0);
    var linePrice = Number(item && item.final_line_price || 0);

    return (
      isTrue(props._j_reward) ||
      isTrue(props._reward1) ||
      isTrue(props._reward2) ||
      isTrue(props._reward3) ||
      isTrue(props._j_auto_gift) ||
      isTrue(props._j_exclusive_gift) ||
      isTrue(props._jcg_gift) ||
      finalPrice === 0 ||
      linePrice === 0 ||
      title.indexOf('FREE GIFT') === 0 ||
      title.indexOf('GIFT:') === 0
    );
  }

  function getVariantKey(item) {
    return String(item.variant_id || item.id || '');
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json();
    });
  }

  function changeItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    }).then(function (res) {
      return res.json();
    });
  }

  function emitCartEvents() {
    document.dispatchEvent(new Event('cart:refresh'));
    document.dispatchEvent(new Event('cart:updated'));
    document.dispatchEvent(new Event('j:cart:mutated'));
  }

  function runGuard() {
    var paidVariants = {};
    var keptFreeVariants = {};
    var changes = [];
    var changed = false;

    if (isRunning) return;

    isRunning = true;

    getCart()
      .then(function (cart) {
        (cart.items || []).forEach(function (item) {
          var variantKey = getVariantKey(item);

          if (!variantKey) return;

          if (!isFreeGiftLine(item)) {
            paidVariants[variantKey] = true;
          }
        });

        (cart.items || []).forEach(function (item) {
          var variantKey = getVariantKey(item);

          if (!variantKey) return;
          if (!isFreeGiftLine(item)) return;

          if (paidVariants[variantKey]) {
            changes.push({
              key: item.key,
              quantity: 0
            });
            return;
          }

          if (keptFreeVariants[variantKey]) {
            changes.push({
              key: item.key,
              quantity: 0
            });
            return;
          }

          keptFreeVariants[variantKey] = true;

          if (Number(item.quantity || 0) > 1) {
            changes.push({
              key: item.key,
              quantity: 1
            });
          }
        });

        return changes.reduce(function (chain, change) {
          return chain.then(function () {
            changed = true;
            return changeItem(change.key, change.quantity);
          });
        }, Promise.resolve());
      })
      .then(function () {
        if (changed) {
          emitCartEvents();
        }
      })
      .catch(function () {})
      .finally(function () {
        isRunning = false;
      });
  }

  function queueGuard(delay) {
    if (timer) clearTimeout(timer);

    timer = setTimeout(function () {
      runGuard();
    }, typeof delay === 'number' ? delay : 300);
  }

  document.addEventListener('DOMContentLoaded', function () {
    queueGuard(700);
  });

  document.addEventListener('cart:refresh', function () {
    queueGuard(500);
  });

  document.addEventListener('cart:updated', function () {
    queueGuard(500);
  });

  document.addEventListener('j:cart:mutated', function () {
    queueGuard(500);
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-quantity-value]')) {
      queueGuard(350);
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('[data-quantity-selector], [data-action-atc], [data-cart-remove], button[type="submit"]')) {
      queueGuard(650);
    }
  });

  window.addEventListener('pageshow', function () {
    queueGuard(700);
  });

  window.JCartFreeGuard = {
    run: runGuard,
    queue: queueGuard
  };
})();